module.exports = {
  apiUrl:
    process.env.REACT_APP_ENV === "local"
      ? "http://localhost:4000/local"
      : ["development", "staging"].includes(process.env.REACT_APP_ENV)
      ? "https://75iak1zu36.execute-api.eu-west-3.amazonaws.com/dev"
      : "https://4p64xq2c81.execute-api.eu-west-3.amazonaws.com/prod",
  s3BaseUrl: "https://mediavote-uploads.s3.eu-west-3.amazonaws.com/",
};
